import axios from 'axios'
// 封装axios
const service = axios.create({
}) 

service.interceptors.response.use(res => {
  return res
}, error => {
  // console.log(error)
//   if (error.code === 'ECONNABORTED' && error.message.indexOf('timeout') !== -1) {
  // Toast.fail('请求超时')
//   }
//   return Promise.reject(error) // 在调用的那边可以拿到(catch)你想返回的错误信息
})
export default service



// WEBPACK FOOTER //
// ./src/api/axios.js